import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import LogoPosition from "../../components/LogoPosition";
import Button from "../../elements/Button";
import show from "../../../src/images/view.png";
import hide from "../../../src/images/hide.png";
import "../../style/ResetPassword.scss";
import axios from "axios";
import { API } from "../../services/base";
import { useNavigate } from "react-router-dom";
import { useTransition, animated } from "react-spring";

const ResetPassword = () => {
  // Get the location object from React Router
  const location = useLocation();

  // Extract the token from the query parameters
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  const email = searchParams.get("email");
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  const [repeatPassword, setRepeatPassword] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  const [error, setError] = useState("");

  const transitions = useTransition(openPopup, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    delay: 300,
  });

  const popupTransitions = useTransition(openPopup, {
    from: { opacity: 0, transform: "translateX(100%)" },
    enter: { opacity: 1, transform: "translateX(100%)" },
    leave: { opacity: 0, transform: "translateX(100%)" },
    delay: 300,
  });
  const navigate = useNavigate();

  const handleClick = () => {
    const data = {
      email: email,
      token: token,
      password: password,
      passwordConfirm: repeatPassword,
    };

    axios
      .post(`${API}/auth/forgot-password/change`, data)
      .then((res) => {
        setOpenPopup(true);
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      })
      .catch((err) => {
        console.log(err?.response?.data?.errors);
        setError(err?.response?.data?.messages);
      });
  };

  const handleRedirect = () => {
    navigate("/");
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setError("");
  };

  const handleRepeatPasswordChange = (e) => {
    setRepeatPassword(e.target.value);
    setError("");
  };

  return (
    <div className="resetPasswordScreen">
      {transitions(
        (styles, item) =>
          item && (
            <animated.div
              style={styles}
              className="popupBackground"
              onClick={() => setOpenPopup(false)}
            ></animated.div>
          )
      )}

      {popupTransitions(
        (styles, item) =>
          item && (
            <animated.div style={styles} className="matchPopup">
              <div className="matchContent">
                <h3>Password reset successfully!</h3>
              </div>
            </animated.div>
          )
      )}
      <div className="content">
        <a onClick={handleRedirect}>
          <LogoPosition />
        </a>
        <div className="formContent">
          <div className="innerContent">
            <h3>RESET PASSWORD</h3>
            <div className="form">
              <div style={{ position: "relative" }}>
                <label>Password</label>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter Password..."
                  onChange={handlePasswordChange}
                />
                {error ? <p className="errorMessage">{error.password}</p> : ""}
                {!showPassword && (
                  <img
                    src={show}
                    className="passwordIcon"
                    onClick={() => {
                      setShowPassword(true);
                    }}
                  />
                )}
                {showPassword && (
                  <img
                    src={hide}
                    className="passwordIcon"
                    onClick={() => {
                      setShowPassword(false);
                    }}
                  />
                )}
              </div>
              <div style={{ position: "relative" }}>
                <label>Repeat Password</label>
                <input
                  type={showRepeatPassword ? "text" : "password"}
                  placeholder="Enter Password..."
                  onChange={handleRepeatPasswordChange}
                />
                {error ? (
                  <p className="errorMessage">{error.passwordConfirm}</p>
                ) : (
                  ""
                )}
                {!showRepeatPassword && (
                  <img
                    src={show}
                    className="passwordIcon"
                    onClick={() => {
                      setShowRepeatPassword(true);
                    }}
                  />
                )}
                {showRepeatPassword && (
                  <img
                    src={hide}
                    className="passwordIcon"
                    onClick={() => {
                      setShowRepeatPassword(false);
                    }}
                  />
                )}
              </div>
              {password && repeatPassword ? (
                <Button
                  className="welcomeScreenBtn"
                  title="Submit"
                  onClick={handleClick}
                />
              ) : (
                <Button
                  className="welcomeScreenBtnDisable"
                  title="Submit"
                  disable={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
